import { render } from "./FormView.vue?vue&type=template&id=6b155363&ts=true"
import script from "./FormView.vue?vue&type=script&lang=ts"
export * from "./FormView.vue?vue&type=script&lang=ts"

import "./FormView.vue?vue&type=style&index=0&id=6b155363&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__